import { render, staticRenderFns } from "./SupportTab.vue?vue&type=template&id=72d4888f&"
import script from "./SupportTab.vue?vue&type=script&lang=js&"
export * from "./SupportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports